import React from "react";
import {MenuComponent} from "../components/MenuComponent";
import {CardComponent} from "../components/CardComponent";
import {Query} from "@apollo/client/react/components";
import {
    Box, Chip,
    FormHelperText,
    Skeleton,
    Typography
} from "@mui/material";
import {withRouter} from "../services/withRouter";
import {LinkCustomComponent} from "../components/LinkCustomComponent";
import GET_RELEASE from "../querys/queryRelease";
import * as emoji from "node-emoji";
import printService from "../services/printService";

class ReleaseComponentPure extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            indexTab: 0
        };
    }

    render() {
        return (
            <>
                <MenuComponent/>
                <header className="content">
                    <CardComponent style={{width: '800px'}}>
                        <Query query={GET_RELEASE}
                               variables={{idRelease: this.props.params.idRelease}}>
                            {({data, loading, error}) => {
                                if (loading) {
                                    return (
                                        <Box sx={{width: '800px'}}>
                                            <Skeleton animation="wave"/>
                                            <Skeleton animation="wave"/>
                                            <Skeleton animation="wave"/>
                                            <Skeleton animation="wave"/>
                                            <Skeleton animation="wave"/>
                                            <Skeleton animation="wave"/>
                                        </Box>
                                    )
                                } else if (error) {
                                    return (
                                        <>
                                            <FormHelperText error={true} style={{textAlign: "center"}}>
                                                {error.message}
                                            </FormHelperText>

                                        </>
                                    )
                                } else if (data) {
                                    let createdAt = new Date(parseInt(data.getRelease.created_at));
                                    createdAt = createdAt.toLocaleDateString('pt-BR', {timeZone: 'UTC'});

                                    let description = 'Sem descrição';
                                    if (data.getRelease.description) {
                                        description = data.getRelease.description.replace(/\*/g, "<br />");
                                        description = emoji.emojify(description);
                                    }

                                    return (
                                        <>
                                            <Typography variant="h4" component="h5" textAlign={"left"}>
                                                Entrega {data.getRelease.name} - {data.getRelease.module.name} - {data.getRelease.module.product.name}
                                            </Typography>
                                            <br/>
                                            <Typography variant="subtitle1" component="subtitle2" textAlign={"left"}>
                                                Criado em: {createdAt} -
                                                <LinkCustomComponent to={'./'}
                                                                     onClick={() => printService.print(
                                                                         `Versão ${data.getRelease.name} - ${data.getRelease.module.name} - ${data.getRelease.module.product.name}`,
                                                                         description)}>
                                                    Imprimir
                                                </LinkCustomComponent>
                                            </Typography>
                                            <br/>
                                            <div style={{backgroundColor: '#F1F3F4', padding: 10}}>
                                                <Typography variant="subtitle1" component="subtitle2"
                                                            textAlign={"left"}>
                                                    <td dangerouslySetInnerHTML={{__html: description}}/>
                                                </Typography>
                                            </div>

                                            <br/><br/>

                                            <Typography variant="subtitle1" component="subtitle2" textAlign={"left"}>
                                                Release do produto: <LinkCustomComponent
                                                to={`/product/releases/${data.getRelease.productRelease?.id}`}>
                                                {
                                                    data.getRelease.productRelease ?
                                                        (<Chip clickable={true}
                                                               label={data.getRelease.productRelease.name}
                                                               color="primary"/>) :
                                                        ('Não definido')
                                                }

                                            </LinkCustomComponent>
                                            </Typography>

                                            <br/>

                                            <Typography variant="subtitle1" component="subtitle2" textAlign={"left"}>
                                                Módulo: <LinkCustomComponent
                                                to={`/modules/${data.getRelease.module.id}`}>
                                                <Chip clickable={true} label={data.getRelease.module.name}
                                                      color="primary"/>
                                            </LinkCustomComponent>
                                            </Typography>

                                            <br/>

                                            <Typography variant="subtitle1" component="subtitle2" textAlign={"left"}>
                                                Produto:
                                                <LinkCustomComponent
                                                    to={`/products/${data.getRelease.module.product.id}`}>
                                                    <Chip clickable={true} label={data.getRelease.module.product.name}
                                                          color="primary"/>
                                                </LinkCustomComponent>
                                            </Typography>
                                        </>
                                    )
                                }
                            }}
                        </Query>
                    </CardComponent>
                </header>
            </>
        );
    }
}

export const ReleaseComponent = withRouter(ReleaseComponentPure);
